import Vue from "vue";
import Vuex from "vuex";
import {alert_validation_messages} from "./lib/util";
import {mockData, pickOne} from "./assets/mock-data";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    discountCoupon: {},
    settingsLoaded: false,
    User: {
      ready: false,
      loggedIn: false,
      NewSuiUser: {
      },
      UserForm: {
        "email": "",
        "name": "",
        "surname": "",
        "gender": "",
        "password": "",
        "password_retype": "",
        "address": "",
        "address_2": "",
        "about": "",
        "number": "",
        "state": "",
        "city": "",
        "cep": "",
        "mail_address": "",
        SubmittedData: {
          "email": "",
          "name": "",
          "surname": "",
          "gender": "",
          "password": "",
          "password_retype": "",
          "validation_code": "",
          "address": "",
          "address_2": "",
          "about": "",
          "number": "",
          "state": "",
          "city": "",
          "cep": "",
          "mail_address": ""
        }
      },
      Ephemeral: {
        subStep: "email-prompt",
        formStatus: "empty"
      }
    },
    Subscription: {
      Ephemeral: {
        status: "empty",
        currentStep: "new",
        TeacherToAdd: {
          "email": "",
          "name": "",
          "surname": "",
          "status": "empty"
        },
        teacherBeingRemoved: null,
        Payment: {
          "responsible_name": "",
          "responsible_document": "",
          "responsible_address": "",
          "responsible_address_number": "",
          "responsible_address_neighbor": "",
          "responsible_address_2": "",
          "responsible_address_state": "",
          "responsible_address_city": "",
          "responsible_address_cep": "",
          "responsible_telephone": "",
          "responsible_email": ""
        },
        paymentBeingGenerated: false
      },
      StepsPublicFacingNames: {
        new: "Tipo de inscrição",
        institution: "Seleção de escola",
        teachers: "Formação da(s) equipe(s)",
        terms_and_conditions: "Regulamento",
        registration_report: "Relatório de inscrição"
      },
      subscription_id: 5,
      subscription_slug: 'blergs',
      NewSuiSubscription: {
      },
      NewSuiApplication: {
        modality: null,
        sui_institution_id: null,
        sui_payment_id: null,
        extra_data: {
          _onhbSubscription: {
            Teachers: [
            ],
            agreedToTermsAndConditions: false
          }
        },
        NewSuiPayment: {},
        NewSuiInstitution: {}
      }
    },
    ProcessingStatus: {
      loadingSomething: false,
      modal: false
    },
    InstitutionSearch: {
      searching: false,
      idToSearch: "",
      RetrievedSearch: {
        Criteria: {
          id: "",
        },
        state: "empty",
        Results: [
        ],
        Errors: [
        ]
      }
    },

    // TeamScreen:
    ApplicationsOrder: [],
    Applications: {},
    Members: {},
    ResponsibleUsers: {},
    Teams: {},
    TeamsEphemeral: {
      me: null,
      savingMemberTeamId: null,
      savingMemberIdx: null
    },
    Interface: {
      billetWarn: false,
      newBillet: false,
      newBilletApplication: null,
      cancelApplication: false,
      cancellingApplication: {},
      applicationId: null,
      justSavedApplicationId: null,
    }
  },
  mutations: {
    "SET_DISCOUNT_COUPON": function (state, data) {
      Vue.set(state.discountCoupon, 'sui_coupon_id', data.id);
      Vue.set(state.discountCoupon, 'sui_coupon_code', data.code);
      Vue.set(state.discountCoupon, 'type', data.type);
      Vue.set(state.discountCoupon, 'team_id', data.team_id);
    },
    "RESTART_PROCESS": function (state) {
      Vue.set(state.Subscription,"Ephemeral", {
        status: "empty",
        currentStep: "new",
        TeacherToAdd: {
          "email": "",
          "name": "",
          "surname": "",
          "status": "empty"
        },
        teacherBeingRemoved: null,
        Payment: {
          "responsible_name": "",
          "responsible_document": "",
          "responsible_address": "",
          "responsible_address_number": "",
          "responsible_address_neighbor": "",
          "responsible_address_2": "",
          "responsible_address_state": "",
          "responsible_address_city": "",
          "responsible_address_cep": "",
          "responsible_telephone": "",
          "responsible_email": ""
        },
        paymentBeingGenerated: false
      });
      Vue.set(state.Subscription,"NewSuiApplication", {
        modality: null,
        sui_institution_id: null,
        sui_payment_id: null,
        extra_data: {
          _onhbSubscription: {
            Teachers: [
            ],
            agreedToTermsAndConditions: false
          }
        },
        NewSuiPayment: {},
        NewSuiInstitution: {}
      });
      state.ProcessingStatus.loadingSomething = false;

      Vue.set(state, "InstitutionSearch", {
        searching: false,
            idToSearch: "",
            RetrievedSearch: {
          Criteria: {
            id: "",
          },
          state: "empty",
              Results: [
          ],
              Errors: [
          ]
        }
      });
    },
    "BACK_TO_INSTITUTION": function(state) {
      Vue.set(state.Subscription,"Ephemeral", {
        status: "empty",
        currentStep: "institution",
        TeacherToAdd: {
          "email": "",
          "name": "",
          "surname": "",
          "status": "empty"
        },
        teacherBeingRemoved: null,
        Payment: {
          "responsible_name": "",
          "responsible_document": "",
          "responsible_address": "",
          "responsible_address_number": "",
          "responsible_address_neighbor": "",
          "responsible_address_2": "",
          "responsible_address_state": "",
          "responsible_address_city": "",
          "responsible_address_cep": "",
          "responsible_telephone": "",
          "responsible_email": ""
        },
        paymentBeingGenerated: false
      });
      state.Subscription.NewSuiApplication.sui_payment_id = null;
      Vue.set(state.Subscription.NewSuiApplication, "extra_data",{
        _onhbSubscription: {
          Teachers: [],
          agreedToTermsAndConditions: false
      }});

      state.Subscription.NewSuiApplication.sui_institution_id = null;

      Vue.set(state.Subscription.NewSuiApplication, "NewSuiInstitution",{});

      Vue.set(state.Subscription.NewSuiApplication, "NewSuiPayment",{});

      state.ProcessingStatus.loadingSomething = false;
    },
    "BACK_TO_TEACHERS": function(state) {
      Vue.set(state.Subscription,"Ephemeral", {
        status: "empty",
        currentStep: "teachers",
        TeacherToAdd: {
          "email": "",
          "name": "",
          "surname": "",
          "status": "empty"
        },
        teacherBeingRemoved: null,
        Payment: {
          "responsible_name": "",
          "responsible_document": "",
          "responsible_address": "",
          "responsible_address_number": "",
          "responsible_address_neighbor": "",
          "responsible_address_2": "",
          "responsible_address_state": "",
          "responsible_address_city": "",
          "responsible_address_cep": "",
          "responsible_telephone": "",
          "responsible_email": ""
        },
        paymentBeingGenerated: false
      });
      state.Subscription.NewSuiApplication.sui_payment_id = null;
      state.Subscription.NewSuiApplication.extra_data._onhbSubscription.agreedToTermsAndConditions = false;

      Vue.set(state.Subscription.NewSuiApplication, "NewSuiPayment",{});

      state.ProcessingStatus.loadingSomething = false;
    },

    "BACK_TO_TERMS_AND_CONDITIONS": function(state) {
      Vue.set(state.Subscription,"Ephemeral", {
        status: "empty",
        currentStep: "terms_and_conditions",
        TeacherToAdd: {
          "email": "",
          "name": "",
          "surname": "",
          "status": "empty"
        },
        teacherBeingRemoved: null,
        Payment: {
          "responsible_name": "",
          "responsible_document": "",
          "responsible_address": "",
          "responsible_address_number": "",
          "responsible_address_neighbor": "",
          "responsible_address_2": "",
          "responsible_address_state": "",
          "responsible_address_city": "",
          "responsible_address_cep": "",
          "responsible_telephone": "",
          "responsible_email": ""
        },
        paymentBeingGenerated: false
      });

      state.Subscription.NewSuiApplication.extra_data._onhbSubscription.agreedToTermsAndConditions = false;

      Vue.set(state.Subscription.NewSuiApplication, "NewSuiPayment",{});

      state.ProcessingStatus.loadingSomething = false;
    },

    "START_LOADING": function(state) {
      state.ProcessingStatus.loadingSomething = true;
    },

    "END_LOADING": function(state ) {
      state.ProcessingStatus.loadingSomething = false;
    },

    "CHANGE_USER": function(state, newUser){
      state.ready = true;
      state.user = newUser;
    },

    "NEW_SUBSCRIPTION": function(state, modality) {
      state.Subscription.Ephemeral.status = "starting";
      state.Subscription.NewSuiApplication.sui_subscription_id = state.Subscription.subscription_id;
      state.Subscription.NewSuiApplication.modality = modality;

      if (modality == 'student' || modality == 'teacher' || modality == 'wildcard') {

        state.Subscription.Ephemeral.currentStep = "institution";
        // state.Subscription.NewSuiApplication = {
        //   "sui_subscription_id": state.Subscription.subscription_id, // HARDCODED with current subscription
        //   "modality": modality
        // };

        if (modality === "teacher") {
          let emptyTeacher = {
            email: "",
            "name": "",
            "surname": "",
            "teams": 1,
            "NewSuiUser": {}
          };
          state.Subscription.NewSuiApplication.extra_data._onhbSubscription.Teachers.push(emptyTeacher);
        }
      }
      else {
        state.Subscription.Ephemeral.currentStep = "terms_and_conditions";
      }
    },

    "SELECT_INSTITUTION": function(state, institution) {
      var i, curInst;

      state.Subscription.NewSuiApplication.sui_institution_id = institution;

      //@todo Replace by Safely Searching for current institution again? MAYBE?
      for (i = 0; i < state.InstitutionSearch.RetrievedSearch.Results.length; i ++) {
        var curInst = state.InstitutionSearch.RetrievedSearch.Results[i];

        if (curInst.NewSuiInstitution.id == institution) {
          state.Subscription.NewSuiApplication.NewSuiInstitution = JSON.parse(JSON.stringify(curInst.NewSuiInstitution));
        }
      }
    },

    "UNSELECT_INSTITUTION": function(state) {
      state.Subscription.NewSuiApplication.sui_institution_id = null;
      state.Subscription.NewSuiApplication.NewSuiInstitution = {};
    },

    "START_INSTITUTION_SEARCH": function(state) {
      state.InstitutionSearch.searching = true;
      state.InstitutionSearch.RetrievedSearch.Criteria.id = state.InstitutionSearch.idToSearch;
      state.InstitutionSearch.RetrievedSearch.state = "searching"
    },

    "CHANGE_INSTITUTION_SEARCH_ID": function (state, idToSearch) {
      state.InstitutionSearch.idToSearch = idToSearch;
    },

    "FINISH_INSTITUTION_SEARCH": function(state, results) {
      state.InstitutionSearch.searching = false;
      if (results.status === "ok") {
        state.InstitutionSearch.RetrievedSearch.state = "finished";
      }
      else if (results.status === "error") {
        state.InstitutionSearch.RetrievedSearch.state = "failed";
      }
      state.InstitutionSearch.RetrievedSearch.Results = results.Results;
      state.InstitutionSearch.RetrievedSearch.Errors = results.Errors;
    },

    "GOTO_STEP_TEACHERS": function(state, results) {
      state.Subscription.Ephemeral.currentStep = "teachers";

      if (state.Subscription.NewSuiApplication.modality == 'teacher') {
        //@todo, check if it is necessary
        let teacherData = {
          "name": "", // to be filled with login data once in the registration step
          "surname": "",
          "email": "",
          "teams": "1",
          "NewSuiUser": {}
        };
        state.Subscription.NewSuiApplication.extra_data._onhbSubscription.Teachers.push(teacherData);
      }
    },
    
    "GOTO_STEP_TEAM_COMPOSITION": function(state) {
      state.Subscription.Ephemeral.currentStep = "team-composition";      
    },

    "GOTO_STEP_TERMS_AND_CONDITIONS": function(state) {
      state.Subscription.Ephemeral.currentStep = "terms_and_conditions";
    },

    "GOTO_STEP_USER_ID": function(state) {
      state.Subscription.Ephemeral.currentStep = "user";
    },

    "GOTO_STEP_REGISTRATION_REPORT": function(state) {
      state.Subscription.Ephemeral.currentStep = "report";
    },

    "CLEAR_INSTITUTION_SEARCH": function(state) {
      state.InstitutionSearch.searching = false;
      state.InstitutionSearch.RetrievedSearch.state = "empty";
      state.InstitutionSearch.RetrievedSearch.Results = [];
      state.InstitutionSearch.RetrievedSearch.Errors = [];
      state.InstitutionSearch.RetrievedSearch.Criteria.id = "";
    },
    "START_ADDING_TEACHER": function(state) {
      state.Subscription.Ephemeral.TeacherToAdd.status = "adding";
    },
    "START_REMOVING_TEACHER": function(state, teacher) {
      state.Subscription.Ephemeral.teacherBeingRemoved = state.Subscription.NewSuiApplication.extra_data._onhbSubscription.Teachers.indexOf(teacher);
    },
    "ADD_USER_DATA_TO_TEACHER_LIST": function(state) {
      state.Subscription.NewSuiApplication.extra_data._onhbSubscription.Teachers[0].email = state.User.NewSuiUser.email;
    },
    "ADD_TEACHER": function (state, data) {
      state.Subscription.NewSuiApplication.extra_data._onhbSubscription.Teachers.push(data);
      state.Subscription.Ephemeral.TeacherToAdd.status = "empty";
      state.Subscription.Ephemeral.TeacherToAdd.email = "";
      state.Subscription.Ephemeral.TeacherToAdd.name = "";
      state.Subscription.Ephemeral.TeacherToAdd.surname = "";
    },
    "REMOVE_TEACHER": function (state, teacher) {
      var idx = state.Subscription.NewSuiApplication.extra_data._onhbSubscription.Teachers.indexOf(teacher);
      state.Subscription.NewSuiApplication.extra_data._onhbSubscription.Teachers.splice(idx, 1);
      state.Subscription.Ephemeral.teacherBeingRemoved = null;
    },
    "TEACHER_TO_ADD_CHANGE_EMAIL": function (state, value) {
      state.Subscription.Ephemeral.TeacherToAdd.email = value;
    },
    "TEACHER_TO_ADD_CHANGE_NAME": function (state, value) {
      state.Subscription.Ephemeral.TeacherToAdd.name = value;
    },
    "TEACHER_TO_ADD_CHANGE_SURNAME": function (state, value) {
      state.Subscription.Ephemeral.TeacherToAdd.surname = value;
    },
    "USER_FORM_CHANGE": function(state, {field, value}) {
      state.User.UserForm[field] = value;
    },
    "PAY_FORM_CHANGE": function (state, {field, value}) {
      state.Subscription.Ephemeral.Payment[field] = value;
    },
    "CHANGE_AGREEMENT_STATUS": function (state, value) {
      state.Subscription.NewSuiApplication.extra_data._onhbSubscription.agreedToTermsAndConditions = true && value;
    },
    "SEARCH_OTHER_USER": function (state) {
      state.User.Ephemeral.subStep = 'email-prompt';
      state.User.UserForm.email = "";
      state.User.UserForm.password = "";
      state.User.UserForm.password_retype = "";
      state.User.Ephemeral.formStatus = 'empty';
      state.User.NewSuiUser = {};
    },
    "START_SEARCH_USER": function (state){
      state.User.Ephemeral.formStatus = 'searching';
      state.User.UserForm.SubmittedData.email = state.User.UserForm.email;
      state.User.UserForm.SubmittedData.name = "";
      state.User.UserForm.SubmittedData.surname = "";
      state.User.UserForm.SubmittedData.password = "";
      state.User.UserForm.SubmittedData.password_retype = "";
    },
    "AUTOFILL_EMAIL_IN_LOGIN": function(state) {
      if (state.User.loggedIn) {
        state.User.UserForm.email = state.User.NewSuiUser.email;
      }
    },
    "START_USER_REGISTER": function (state){
      state.User.Ephemeral.subStep = 'register';
      state.User.Ephemeral.formStatus = 'empty';
    },
    "START_LOGIN": function (state){
      state.User.Ephemeral.subStep = 'login';
      state.User.Ephemeral.formStatus = 'empty';
    },
    "LOGIN_USER": function (state, user) {
      state.User.NewSuiUser = user.NewSuiUser;
      state.User.loggedIn = true;
    },
    "UPDATE_USER_DATA": function (state, data){
      state.User.NewSuiUser = data.NewSuiUser;
    },
    "REGISTER_USER_SUBMIT": function (state) {
      state.User.Ephemeral.formStatus = 'saving';
      state.User.UserForm.SubmittedData.email = state.User.UserForm.email;
      state.User.UserForm.SubmittedData.name = state.User.UserForm.name;
      state.User.UserForm.SubmittedData.surname = state.User.UserForm.surname;
      state.User.UserForm.SubmittedData.gender = state.User.UserForm.gender;
      state.User.UserForm.SubmittedData.password = state.User.UserForm.password;
      state.User.UserForm.SubmittedData.password_retype = state.User.UserForm.password_retype;
      state.User.UserForm.SubmittedData.address = state.User.UserForm.address;
      state.User.UserForm.SubmittedData.address_2 = state.User.UserForm.address_2;
      state.User.UserForm.SubmittedData.about = state.User.UserForm.about;
      state.User.UserForm.SubmittedData.number = state.User.UserForm.number;
      state.User.UserForm.SubmittedData.city = state.User.UserForm.city;
      state.User.UserForm.SubmittedData.state = state.User.UserForm.state;
      state.User.UserForm.SubmittedData.cep = state.User.UserForm.cep;
    },
    "END_REGISTER_USER_SUBMIT": function (state){
      state.User.Ephemeral.formStatus = 'empty';
    },

    "START_USER_VALIDATION": function (state){
      state.User.Ephemeral.subStep = 'validation';
      state.User.Ephemeral.formStatus = 'empty';
    },
    "VALIDATE_USER_SUBMIT": function (state) {
      state.User.Ephemeral.formStatus = 'saving';
      state.User.UserForm.SubmittedData.email = state.User.UserForm.email;
      state.User.UserForm.SubmittedData.validation_code = state.User.UserForm.validation_code;
    },
    "END_VALIDATE_USER": function (state){
      state.User.Ephemeral.formStatus = 'empty';
    },

    "END_SEARCH_USER": function (state){
      state.User.Ephemeral.formStatus = 'empty';
    },
    "START_GENERATING_BILLET": function (state) {
      state.Subscription.Ephemeral.paymentBeingGenerated = true;
    },
    "END_GENERATING_BILLET": function (state) {
      state.Subscription.Ephemeral.paymentBeingGenerated = false;
      // state.Subscription.NewSuiApplication.NewSuiPayment = data;
    },
    "CHANGE_TEAMS_LIST": function (state, data) {
      state.ApplicationsOrder = data.ApplicationsOrder;
      state.Applications = data.Applications;
      state.Teams = data.Teams;
      state.Members = data.Members;
      state.ResponsibleUsers = data.ResponsibleUsers; //@todo, include SuiUsers even if they are not payers
    },
    "CHANGE_MEMBER_FORM": function (state, data) {
      Vue.set(state.Members[data.sui_user_id].SuiUserEdit, data.property, data.value);
    },
    "OPEN_TEAM_NAME_EDIT": function(state, teamId) {
      state.Teams[teamId].Ephemeral.editingName = true;
    },
    "UPDATE_TEAM_NAME": function(state, {teamId, value}) {
      state.Teams[teamId].NewSuiApplication.team_name = value;
    },
    "CLOSE_TEAM_NAME_EDIT": function(state, teamId) {
      state.Teams[teamId].Ephemeral.editingName = false;
    },
    "CHANGE_TEAM_NAME": function (state, data) {
      state.Teams[data.teamId].Edit.NewSuiApplication.team_name = data.value;
    },
    "START_SAVING_MEMBER": function (state, {teamId, memberIdx}) {
      state.TeamsEphemeral.savingMemberIdx = memberIdx;
      state.TeamsEphemeral.savingMemberTeamId = teamId;
    },
    "UPDATE_SAVED_MEMBER": function (state, {teamId, index, member, extraData}) {
      state.TeamsEphemeral.savingMemberIdx = null;
      state.TeamsEphemeral.savingMemberTeamId = null;

      if (typeof extraData.auxId != "undefined") { //SOOOO UGLY
        member.NewSuiUser.auxId = extraData.auxId;
        member.NewSuiUser.age = extraData.age;
        member.NewSuiUser.gender = extraData.gender;
        member.NewSuiUser.professor_type = extraData.professor_type;
        member.NewSuiUser.profession = extraData.profession;
        member.NewSuiUser.onhb_already = extraData.onhb_already;
        member.NewSuiUser.schooling = extraData.schooling;
        member.NewSuiUser.state = extraData.state;
        member.NewSuiUser.city = extraData.city;
      }

      member.NewSuiUser.exemptionApproved = member.extra_data.exemptionApproved || null;
      member.NewSuiUser.approvalReasoning = member.extra_data.approvalReasoning || null;

      if (typeof (member.extra_data.exemption) != "undefined") {
        member.NewSuiUser.exemption = member.extra_data.exemption;
      }
      if (typeof (member.extra_data.exemptionStamp) != "undefined") {
        member.NewSuiUser.exemptionStamp = member.extra_data.exemptionStamp;
      }
      if (typeof (member.extra_data.exemptionProof) != "undefined") {
        member.NewSuiUser.exemptionProof = member.extra_data.exemptionProof;
      }

      member.SuiUserEdit = JSON.parse(JSON.stringify(member.NewSuiUser));
      member.Ephemeral= {editing: false};

      state.Teams[teamId].NewSuiApplicationsNewSuiUser[index].sui_user_id = member.NewSuiUser.id;
      state.Teams[teamId].NewSuiApplicationsNewSuiUser[index].id = member.id;

      Vue.set(state.Members, member.NewSuiUser.id, member);

    },
    "UPDATE_EDITED_MEMBER_INFO": function (state, {teamId, index, memberData}) {
      let memberId = state.Teams[teamId].NewSuiApplicationsNewSuiUser[index].sui_user_id;
      state.Members[memberId].Ephemeral.editing = false;

      Vue.set(state.Members[memberId].NewSuiUser, 'auxId', memberData.auxId);
      if (index > 0) {
        state.Members[memberId].NewSuiUser.name = memberData.name;
        state.Members[memberId].NewSuiUser.surname = memberData.surname;
      }
      Vue.set(state.Members[memberId].NewSuiUser,"age", memberData.age);
      Vue.set(state.Members[memberId].NewSuiUser, "onhb_already", memberData.onhb_already);
      Vue.set(state.Members[memberId].NewSuiUser, "profession",  memberData.profession);
      Vue.set(state.Members[memberId].NewSuiUser, "gender", memberData.gender);
      Vue.set(state.Members[memberId].NewSuiUser, "professor_type", memberData.professor_type);
      Vue.set(state.Members[memberId].NewSuiUser, "schooling", memberData.schooling);
      Vue.set(state.Members[memberId].NewSuiUser, "state", memberData.state);
      Vue.set(state.Members[memberId].NewSuiUser, "city", memberData.city);
      if (typeof memberData.extra_data.exemption != "undefined") {
        Vue.set(state.Members[memberId].NewSuiUser, "exemption", memberData.extra_data.exemption);
      }
      if (typeof memberData.extra_data.exemptionProof != "undefined") {
        Vue.set(state.Members[memberId].NewSuiUser, "exemptionProof", memberData.extra_data.exemptionProof);
      }
      if (typeof memberData.extra_data.exemptionStamp != "undefined") {
        Vue.set(state.Members[memberId].NewSuiUser, "exemptionStamp", memberData.extra_data.exemptionStamp);
      }
    },
    "START_MEMBER_EDIT": function (state, memberId) {
      state.Members[memberId].Ephemeral.editing = true;
    },
    "CANCEL_MEMBER_EDIT": function (state, memberId) {
      state.Members[memberId].SuiUserEdit = JSON.parse(JSON.stringify(state.Members[memberId].NewSuiUser));
      state.Members[memberId].Ephemeral.editing = false;
    },
    "REMOVE_MEMBER": function (state, {teamId, index}) {
      let randomId = `NEW-${teamId}-${index}-${Math.floor(Math.random() * 100000000)}`,
          randomUser = {
            "NewSuiUser": {
              "id": randomId,
              "name": "",
              "surname": "",
              "sui_grade_id": "",
              "user_status": "unsaved",
              "email": "",
              "professor_type": "-",
              "exemption": "false",
              "exemptionStamp": "",
              "exemptionLink": ""
            },
            "Ephemeral": {
              "editing": true
            }
          };

      state.Teams[teamId].NewSuiApplicationsNewSuiUser[index].sui_user_id = randomUser.NewSuiUser.id;
      randomUser.SuiUserEdit = JSON.parse(JSON.stringify(randomUser.NewSuiUser));

      Vue.set(state.Members, randomUser.NewSuiUser.id, randomUser);
    },
    "ADD_EXTRA_MEMBER": function (state, {teamId}) {
      let randomId = "NEW-EXTRA-" + Math.floor(Math.random() * 100000000);

      state.Teams[teamId].NewSuiApplicationsNewSuiUser.push({
        "sui_user_id": randomId,
        "role_code": "membro"
      });

      Vue.set(state.Members, randomId, {
        "NewSuiUser": {
          "id": randomId,
          "name": "",
          "surname": "",
          "sui_grade_id": "",
          "gender": "",
          "user_status": "unsaved",
          "email": "",
          "professor_type": "-"
        },
        "Ephemeral": {
          "editing": true
        }
      });

      let tmp = JSON.parse(JSON.stringify(state.Members[randomId].NewSuiUser));

      Vue.set(state.Members[randomId], 'SuiUserEdit', tmp);

      delete state.Members[randomId].SuiUserEdit.id;
    },
    "START_MODAL": function (state) {
      state.ProcessingStatus.modal = true;
    },
    "END_MODAL": function (state) {
      state.ProcessingStatus.modal = false;
    },
    "OPEN_BILLET_WARN": function (state, {applicationId}) {
      state.ProcessingStatus.modal = true;
      state.Interface.billetWarn = true;
      state.Interface.applicationId = applicationId;
    },
    "CLOSE_BILLET_WARN": function (state) {
      state.ProcessingStatus.modal = false;
      state.Interface.billetWarn = false;
      state.Interface.applicationId = null;
    },
    "REGISTER_JUST_SAVED_PROCESS": function (state, applicationId) {
      state.Interface.justSavedApplicationId = applicationId;
    },
    "OPEN_CANCEL_PROCESS_MODAL": function (state, data) {
      state.ProcessingStatus.modal = true;
      state.Interface.cancelApplication = true;
      Vue.set(state.Interface, 'cancellingApplication', data);
    },
    "CLOSE_CANCEL_PROCESS_MODAL": function (state) {
      state.ProcessingStatus.modal = false;
      state.Interface.cancelApplication = false;
    },
    "OPEN_NEW_BILLET_MODAL": function (state, application) {
      state.ProcessingStatus.modal = true;
      state.Interface.newBillet = true;
      state.Interface.newBilletApplication = application;

      let stateApplication = state.Subscription.NewSuiApplication;

      stateApplication.id = application.NewSuiApplication.id;
      stateApplication.code = application.NewSuiApplication.code;
      stateApplication.sui_institution_id = application.NewSuiApplication.sui_institution_id;
      stateApplication.modality = application.NewSuiApplication.modality;
      stateApplication.extra_data = application.NewSuiApplication.extra_data;
      ["id", "name", "type", "state", "city"].forEach(function (field) {
        stateApplication.NewSuiInstitution[field] = application.NewSuiInstitution[field];
      });

      [
        "responsible_name",
        "responsible_document",
        "responsible_address",
        "responsible_address_number",
        "responsible_address_neighbor",
        "responsible_address_2",
        "responsible_address_state",
        "responsible_address_city",
        "responsible_address_cep",
        "responsible_telephone",
        "responsible_email",
        "sui_coupon_id",
        "sui_coupon_code",
        "sui_coupon_application_id"
      ].forEach(function (field) {
          state.Subscription.Ephemeral.Payment[field] =
          stateApplication.NewSuiPayment[field] = application.NewSuiPayment[field];
      })
    },
    "CLEAR_BILLET_FORM": function (state) {
      [
        "responsible_name",
        "responsible_document",
        "responsible_address",
        "responsible_address_number",
        "responsible_address_neighbor",
        "responsible_address_2",
        "responsible_address_state",
        "responsible_address_city",
        "responsible_address_cep",
        "responsible_telephone",
        "responsible_email"
      ].forEach(function (field) {
          state.Subscription.Ephemeral.Payment[field] = state.Subscription.NewSuiApplication.NewSuiPayment[field] = "";
      })
    },
    "CLOSE_NEW_BILLET_MODAL": function (state) {
      state.ProcessingStatus.modal = false;
      state.Interface.newBillet = false;
    },
    "UPDATE_SUBSCRIPTION_SETTINGS": function (state, data) {
      let NewSuiSubscription = data.NewSuiSubscription;
      NewSuiSubscription.CurrentPeriod = data.CurrentPeriod;
      state.NewSuiSubscription = NewSuiSubscription;
      state.Subscription.subscription_slug = NewSuiSubscription.slug;
      if (state.Subscription.subscription_slug.length > 0) {
        state.settingsLoaded = true;
      }
    }
  },
  actions: {
    startNewSubscription: function (context, modality) {
      context.commit("NEW_SUBSCRIPTION", modality);
    },
    searchForSchool: function (context) {
      if (context.state.amILoading) {
        return;
      }

      context.commit("START_LOADING");
      context.commit("START_INSTITUTION_SEARCH");
      let promise;

      if (process.env.VUE_APP_API_MODE === "mock") {
        promise = new Promise(function(resolve) {
          setTimeout(function() {
                let results = pickOne(mockData.InstitutionSearch);

                if (results.length > 0) {
                  context.commit("FINISH_INSTITUTION_SEARCH", {
                    status: "ok",
                    Results: results,
                    Errors: []
                  });
                } else {
                  context.commit("FINISH_INSTITUTION_SEARCH", {
                    status: "ok",
                    Results: results,
                    Errors: []
                  });
                }
                resolve();
              },
              600);
        });
      }
      else {
        const institutionId = context.state.InstitutionSearch.RetrievedSearch.Criteria.id;
        if (typeof institutionId === "undefined" || institutionId === "") {
          promise = Promise.resolve(null);
        }
        else {
          promise = Vue.axios
              .get('new_sui_institution/' + encodeURIComponent(institutionId) + '.json')
              .then(
                  function (result) {
                    let Errors = [], Results = result.data;
                    if (Results.NewSuiInstitution) {
                      Results = [{NewSuiInstitution: Results.NewSuiInstitution}];
                    }
                    context.commit("FINISH_INSTITUTION_SEARCH", {Results, Errors, status: "ok"});
                  },
                  function (error) {
                    let Errors = [], Results = [];
                    if (error.response.status === 404) {
                      context.commit("FINISH_INSTITUTION_SEARCH", {Results, Errors, status: "ok"});
                      return;
                    }
                    context.commit("FINISH_INSTITUTION_SEARCH", {Results, Errors, status: "error"});
                  });
        }
      }

      return promise
          .finally(function () {
            context.commit("END_LOADING");
          });
    },
    createBillet: function(context) {
      context.commit("START_LOADING");
      context.commit("START_GENERATING_BILLET");

      let promise;
      if (process.env.VUE_APP_API_MODE === "mock") {
        promise = new Promise(function (resolve, reject) {
          setTimeout(function() {
            let result = {data: pickOne(mockData.GenerateBillet)};
            if (typeof result.NewSuiPayment != "undefined") {
              resolve(result);
            }
            else {
              reject(result);
            }
          }, 600)
        });
      }
      else {
        let params = {
              sui_user: context.state.User.NewSuiUser.id,
              subscription: context.state.Subscription.subscription_slug
            },
            data = {};
        let modality = context.state.Subscription.NewSuiApplication.modality;

        //if (context.getters.currentSubsModel == 'onhb') {
        if (modality == 'student' || modality == 'teacher' || modality == 'wildcard') {
          data = {
            "NewSuiPayment": context.state.Subscription.Ephemeral.Payment,
            "NewSuiApplication": context.state.Subscription.NewSuiApplication
          };
        } else {
          data = {
            "NewSuiApplication": context.state.Subscription.NewSuiApplication
          };
        }
        promise = Vue.axios.post('new_sui_application.json?' + (new URLSearchParams(params).toString()), data)
      }

      return promise.then(
            function (response) {
              if (!response.data.saved) {
                let firstLine = "Não foi possível continuar.",
                    lastLine = context.getters.currentSubsModel !== 'onhb' ? "Você será direcionado para a página de dados de sua equipe" : "";

                if (response.data.validation.NewSuiPayment) {
                  alert_validation_messages(response.data.validation.NewSuiPayment, firstLine, lastLine);
                }
                else {
                  alert_validation_messages(response.data.validation, firstLine, lastLine);
                }

                if (context.getters.currentSubsModel !== 'onhb') {
                  location.href = 'team-composition';
                }

                return Promise.reject('validation');
              }
              else {
                context.commit("REGISTER_JUST_SAVED_PROCESS", response.data.saved_id);
              }
            },
            function (error) {
              try {
                if (error.response.data.message === 'Not accepting new applications') {
                  alert("Inscrições encerradas");
                  return Promise.reject(error);
                }
              }
              // eslint-disable-next-line no-empty
              catch (e) {}

              if (context.getters.currentSubsModel === 'onhb') {
                alert("Ocorreu uma falha ao gerar o boleto.");
              }
              else {
                alert("Ocorreu uma falha e não foi possível continuar.");
              }
              return Promise.reject(error);
            }
          )
          .finally(function () {
            context.commit("END_GENERATING_BILLET");
            context.commit("END_LOADING");
          });
    },
    registerInvitedTeachers: function(context, teachers) {
      // context.commit("REGISTER_INVITED_TEACHERS", teachers);
      context.commit("GOTO_STEP_TERMS_AND_CONDITIONS");
    },
    selectSchool: function(context, id) {
      context.commit("SELECT_INSTITUTION", id);
      if (context.getters.currentModality == 'student') {        
        context.commit("GOTO_STEP_TERMS_AND_CONDITIONS");
      } else {
        context.commit("GOTO_STEP_TEACHERS");
      }

    },
    unselectSchool: function(context, id) {
      context.commit("UNSELECT_INSTITUTION");
      context.commit("CLEAR_INSTITUTION_SEARCH");
    },

    addNewTeacher: function(context) {

      let valid = true, teacherForm = context.state.Subscription.Ephemeral.TeacherToAdd;

      ["name", "surname", "email"].forEach(function (field) {
        if (!teacherForm[field] || !teacherForm[field].trim()) {
          valid = false;
        }
      });

      if (!validEmail(teacherForm.email)) {
        valid = false;
      }

      if (!valid) {
        alert("Preencha todos os dados do professor.");
        return;
      }


      context.commit("START_ADDING_TEACHER");
      context.commit("ADD_TEACHER", {
        "name":    teacherForm.name,
        "surname": teacherForm.surname,
        "email":   teacherForm.email,
        "teams": "1",
        "NewSuiUser": {
        }
      });

      function validEmail (email) {
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }
    },
    removeTeacher: function(context, teacher) {
      context.commit("START_REMOVING_TEACHER", teacher);
      context.commit("REMOVE_TEACHER", teacher);
    },
    goToUserId: function(context) {
      context.commit("GOTO_STEP_USER_ID");
      if (context.state.User.loggedIn) {
        context.commit("START_LOGIN");
        context.commit("AUTOFILL_EMAIL_IN_LOGIN");
      }
    },
    goToRegistrationReport: function(context) {
      context.commit("GOTO_STEP_REGISTRATION_REPORT")
    },
    searchUser: function(context) {

      let promise, email = context.state.User.UserForm.email;
      if (typeof email === "undefined" || email === "") {
        return;
      }

      context.commit("START_SEARCH_USER");
      context.commit("START_LOADING");

      if (process.env.VUE_APP_API_MODE === "mock") {
        promise = new Promise(function (resolve) {
          setTimeout(function () {
            resolve({data: pickOne(mockData.SuiUsers)})
          }, 600)
        })
      }
      else {
        promise = Vue.axios
            .get('new_sui_user.json?' + (new URLSearchParams({email}).toString()))
      }

      return promise
          .then(
            function (result) {
              let foundUser = result.data;
              if (result.data.NewSuiUser) {
                foundUser = {NewSuiUser: result.data.NewSuiUser}
              }

              if (!foundUser.NewSuiUser || !foundUser.NewSuiUser.email) {
                context.commit("START_USER_REGISTER");
              }
              else if (foundUser.NewSuiUser.user_status === "new" || foundUser.NewSuiUser.user_status === "invited") {
                context.commit("START_USER_VALIDATION");
              }
              else {
                context.commit("START_LOGIN");
                context.commit("UPDATE_USER_DATA", foundUser);
              }
            },
            function (error) {
              if (error.response.status === 404) {
                context.commit("START_USER_REGISTER");
                return error;
              }
              if (error.response.status === 400 && error.response.data.message) {
                alert(error.response.data.message);
              }
            }
          )
          .finally(function () {
            context.commit("END_LOADING");
            context.commit("END_SEARCH_USER");
          });
    },
    searchOtherUser: function (context) {
      context.commit("SEARCH_OTHER_USER");
    },

    updateTeamsList: function (context) {
      let promise;
      if (process.env.VUE_APP_API_MODE === "mock") {
        promise = new Promise(function (resolve) {
          setTimeout(function () {
            resolve({
              payApps: pickOne(mockData.PaymentApplications),
              teamApps: pickOne(mockData.TeamApplications)
            });
          }, 600)
        })
      }
      else {
        let suiUserId = context.state.User.NewSuiUser.id;

        promise = Vue.axios.get(`new_sui_application.json?sui_user=${suiUserId}&subscription=`+context.state.Subscription.subscription_slug).then(function(response) {
            return new Promise(function(resolve) {
              resolve({
                "payApps": response.data.ParentApplication,
                "teamApps": response.data.ChildApplication
              });
            });
          }
        );
      }

      return promise.then( function({payApps, teamApps}) {
          var i, j;
          var ApplicationsOrder = [], Applications = {}, Teams = {}, Members = {}, ResponsibleUsers = {};
          var randomId;

          // if (context.getters.currentSubsModel == 'onhb') {
          if (context.state.Subscription.subscription_slug == 'omu_2026' || context.state.Subscription.subscription_slug == 'omu_2026_hyw') {
            for (i = 0; i < teamApps.length; i++) {

              let hasTeacher = true;

              teamApps[i].NewSuiApplicationsNewSuiUser.sort(function (a, b) {
                if (a.role_code == "orientador") {
                  return -1;
                }

                if (b.role_code == "orientador") {
                  return 1;
                }

                if (parseInt(a.sui_user_id) < parseInt(b.sui_user_id)) return -1;
                if (parseInt(a.sui_user_id) > parseInt(b.sui_user_id)) return 1;
                return 0;
              });

              if (!teamApps[i].NewSuiApplicationsNewSuiUser.length || teamApps[i].NewSuiApplicationsNewSuiUser[0].role_code != "orientador") {
                hasTeacher = false;
              }

              for (j = 0; j < 4; j++) {
                if (j < teamApps[i].NewSuiApplicationsNewSuiUser.length) { //already present member
                  if (typeof teamApps[i].NewSuiApplicationsNewSuiUser[j].extra_data.exemption != "undefined") {
                    teamApps[i].NewSuiApplicationsNewSuiUser[j].NewSuiUser.exemption = teamApps[i].NewSuiApplicationsNewSuiUser[j].extra_data.exemption;
                  }
                  if (typeof teamApps[i].NewSuiApplicationsNewSuiUser[j].extra_data.exemptionStamp != "undefined") {
                    teamApps[i].NewSuiApplicationsNewSuiUser[j].NewSuiUser.exemptionStamp = teamApps[i].NewSuiApplicationsNewSuiUser[j].extra_data.exemptionStamp;
                  }
                  if (typeof teamApps[i].NewSuiApplicationsNewSuiUser[j].extra_data.exemptionProof != "undefined") {
                    teamApps[i].NewSuiApplicationsNewSuiUser[j].NewSuiUser.exemptionProof = teamApps[i].NewSuiApplicationsNewSuiUser[j].extra_data.exemptionProof;
                  }
                  
                  teamApps[i].NewSuiApplicationsNewSuiUser[j].NewSuiUser.exemptionApproved = teamApps[i].NewSuiApplicationsNewSuiUser[j].extra_data.exemptionApproved || null;
                  teamApps[i].NewSuiApplicationsNewSuiUser[j].NewSuiUser.approvalReasoning = teamApps[i].NewSuiApplicationsNewSuiUser[j].extra_data.approvalReasoning || null;

                  Members[teamApps[i].NewSuiApplicationsNewSuiUser[j].sui_user_id] = {
                    NewSuiUser: teamApps[i].NewSuiApplicationsNewSuiUser[j].NewSuiUser,
                    SuiUserEdit: JSON.parse(JSON.stringify(teamApps[i].NewSuiApplicationsNewSuiUser[j].NewSuiUser)),
                    Ephemeral: {editing: false}
                  };
                } else {
                  randomId = "NEW-" + i + "-" + j + "-" + Math.floor(Math.random() * 100000000);

                  teamApps[i].NewSuiApplicationsNewSuiUser[j] = {
                    "sui_user_id": randomId,
                    "role_code": !hasTeacher ? "orientador" : "membro"
                  };

                  if (!hasTeacher) {
                    hasTeacher = true;
                  }

                  Members[randomId] = {
                    "NewSuiUser": {
                      "id": randomId,
                      "name": "",
                      "surname": "",
                      "sui_grade_id": "",
                      "gender": "",
                      "user_status": "unsaved",
                      "email": "",
                      "professor_type": "-"
                    },
                    "Ephemeral": {
                      "editing": true
                    }
                  };

                  Members[randomId].SuiUserEdit = JSON.parse(JSON.stringify(Members[randomId].NewSuiUser));

                  delete (Members[randomId].SuiUserEdit.id);
                }
              }

              //SORT AGAIN
              teamApps[i].NewSuiApplicationsNewSuiUser.sort(function (a, b) {
                if (a.role_code == "orientador") {
                  return -1;
                }

                if (b.role_code == "orientador") {
                  return 1;
                }

                if (parseInt(a.sui_user_id) < parseInt(b.sui_user_id)) return -1;
                if (parseInt(a.sui_user_id) > parseInt(b.sui_user_id)) return 1;
                return 0;
              });

              Teams[teamApps[i].NewSuiApplication.id] = teamApps[i];
              Teams[teamApps[i].NewSuiApplication.id].Edit = JSON.parse(JSON.stringify(teamApps[i]));
              Teams[teamApps[i].NewSuiApplication.id].Ephemeral = {
                editingName: false
              };
            }

          } else {
            for (i = 0; i < teamApps.length; i++) {

              let modality = payApps[0].NewSuiApplication.modality;
              let maxCount = 2;
              let memberData = teamApps[i].NewSuiApplication.extra_data._onhbSubscription.memberData;

              if (modality == 'pre_individual') {
                maxCount = 1;
              }

              if (modality == 'pre_residencia') {
                maxCount = Math.min(12,parseInt(teamApps[i].NewSuiApplication.extra_data._onhbSubscription.members + 1));
              }

              if (modality == 'pre_zapzap') {
                maxCount = Math.min(5,parseInt(teamApps[i].NewSuiApplication.extra_data._onhbSubscription.members + 1));
              }

              for (j = 0; j < maxCount; j++) {
                let memberId;

                if (j < teamApps[i].NewSuiApplicationsNewSuiUser.length) { //already present member
                  memberId = teamApps[i].NewSuiApplicationsNewSuiUser[j].sui_user_id
                  Members[memberId] = {
                    NewSuiUser: teamApps[i].NewSuiApplicationsNewSuiUser[j].NewSuiUser,
                    SuiUserEdit: JSON.parse(JSON.stringify(teamApps[i].NewSuiApplicationsNewSuiUser[j].NewSuiUser)),
                    Ephemeral: {editing: true}
                  };
                } else {
                  memberId = randomId = "NEW-" + i + "-" + j + "-" + Math.floor(Math.random() * 100000000);

                  teamApps[i].NewSuiApplicationsNewSuiUser[j] = {
                    "sui_user_id": randomId,
                    "role_code": "membro"
                  };

                  Members[randomId] = {
                    "NewSuiUser": {
                      "id": randomId,
                      "name": "",
                      "surname": "",
                      "sui_grade_id": "",
                      "gender": "",
                      "user_status": "unsaved",
                      "email": "",
                      "professor_type": "-"
                    },
                    "Ephemeral": {
                      "editing": true
                    }
                  };

                  Members[randomId].SuiUserEdit = JSON.parse(JSON.stringify(Members[randomId].NewSuiUser));

                  delete (Members[randomId].SuiUserEdit.id);
                }

                if (typeof(memberData[j]) != "undefined") {
                  let keys = ["age", "gender", "professor_type", "profession", "schooling", "auxId", "name", "surname", "onhb_already", "state", "city"];
                  let key;
                  for (key in keys) {
                    Members[memberId].NewSuiUser[keys[key]] = memberData[j][keys[key]];
                    Members[memberId].SuiUserEdit[keys[key]] = memberData[j][keys[key]];
                  }
                  if (typeof Members[memberId].NewSuiUser.auxId == 'undefined') {
                    Members[memberId].Ephemeral.editing = true;
                  }
                  else {
                    Members[memberId].Ephemeral.editing = false;
                  }
                }
              }


              Teams[teamApps[i].NewSuiApplication.id] = teamApps[i];
              Teams[teamApps[i].NewSuiApplication.id].Edit = JSON.parse(JSON.stringify(teamApps[i]));
              Teams[teamApps[i].NewSuiApplication.id].Ephemeral = {
                editingName: false
              };
            }
          }

          for (i = 0; i < teamApps.length; i++) {
            for (j = 0; j < teamApps[i].NewSuiApplicationsNewSuiUser.length; j++) {
              if (teamApps[i].NewSuiApplicationsNewSuiUser[j].role_code == 'orientador') {
                ResponsibleUsers[teamApps[i].NewSuiApplicationsNewSuiUser[j].sui_user_id] = {NewSuiUser: teamApps[i].NewSuiApplicationsNewSuiUser[j].NewSuiUser};
              }
            }
          }

          for (i = 0; i < payApps.length; i++) {
            ApplicationsOrder.push(payApps[i].NewSuiApplication.id);
            Applications[payApps[i].NewSuiApplication.id] = payApps[i];
            Applications[payApps[i].NewSuiApplication.id].Teams = [];
            ResponsibleUsers[payApps[i].NewSuiPayment.sui_user_id] = {NewSuiUser: payApps[i].NewSuiPayment.NewSuiUser};
            for (j = 0; j < teamApps.length; j++) {
              if (teamApps[j].NewSuiApplication.parent_application_id == payApps[i].NewSuiApplication.id) {
                Applications[payApps[i].NewSuiApplication.id].Teams.push(teamApps[j].NewSuiApplication.id);
              }
            }
          }

          context.commit("CHANGE_TEAMS_LIST", {ApplicationsOrder: ApplicationsOrder, Applications: Applications, Teams: Teams, Members:Members, ResponsibleUsers: ResponsibleUsers} );
        }
      );
    },
    editMemberInfo: function (context, {teamId, index}) {
      context.commit("START_LOADING");

      let promise,
          currentLinkId = context.state.Teams[teamId].NewSuiApplicationsNewSuiUser[index].id,
          currentMemberId = context.state.Teams[teamId].NewSuiApplicationsNewSuiUser[index].sui_user_id,
          formUserData = context.state.Members[currentMemberId].SuiUserEdit,
          modality = context.state.Applications[context.state.Teams[teamId].NewSuiApplication.parent_application_id].NewSuiApplication.modality
      ;

      let params = {
            action: "save_member_extra_data",
            sui_user: context.state.User.NewSuiUser.id,
            subscription: context.state.Subscription.subscription_slug,
            application: teamId,
            idx: index
          },
          data = {
            auxId: currentMemberId,
            name: formUserData.name,
            surname: formUserData.surname,
            profession: formUserData.profession,
            age: formUserData.age,
            gender: formUserData.gender,
            professor_type: formUserData.professor_type,
            schooling: formUserData.schooling,
            onhb_already: formUserData.onhb_already,
            state: formUserData.state,
            city: formUserData.city
          };

      promise = Vue.axios.post('new_sui_application.json?' + (new URLSearchParams(params).toString()), data);

      return promise.then(
          function(response) {
            if (!response.data.saved) {
              alert_validation_messages(response.data.validation, "Não foi possível editar os dados do componente da equipe.");
              return;
            }

            context.commit("UPDATE_EDITED_MEMBER_INFO", {
              teamId: teamId,
              index: index,
              memberData: data
            });

            let maxMembers;

            switch (modality) {
              case "pre_individual":
                maxMembers = 1;
                break;
              case "pre_residencia":
                maxMembers = 30; // just for people do not go wild
                break;
            }

            if (context.state.Teams[teamId].NewSuiApplicationsNewSuiUser.length - 1 == index && index < maxMembers - 1) {
              context.commit("ADD_EXTRA_MEMBER", {teamId});
            }

          },
          function () {
            alert("Falha ao editar dados o componente da equipe")
          }
      ).
      finally(function () {
        context.commit("END_LOADING");
      });
    },
    inviteMember: function(context, {teamId, index}) {
      context.commit("START_LOADING");
      context.commit("START_SAVING_MEMBER", {
        teamId: teamId,
        memberIdx: index
      });

      let promise,
          currentLinkId = context.state.Teams[teamId].NewSuiApplicationsNewSuiUser[index].id,
          currentMemberId = context.state.Teams[teamId].NewSuiApplicationsNewSuiUser[index].sui_user_id,
          currentMemberStatus = context.state.Members[currentMemberId].NewSuiUser.user_status,
          formUserData = context.state.Members[currentMemberId].SuiUserEdit,
          extraData = {}
      ;

      if (process.env.VUE_APP_API_MODE === "mock") {
        promise = new Promise(function(resolve){
          setTimeout(function() {
            let memberAdded = JSON.parse(JSON.stringify(pickOne(mockData.Members)));

            if (currentMemberStatus === 'unsaved') {
              memberAdded.NewSuiUser.id = "" + Math.floor(Math.random() * 9999999999);
            } else {
              memberAdded.NewSuiUser.id = currentMemberId;
            }

            resolve({NewSuiApplicationsNewSuiUser: {NewSuiUser: memberAdded}});
          }, 800);
        });
      }
      else {
        let params = {
              action: "invite_member",
              sui_user: context.state.User.NewSuiUser.id,
              subscription: context.state.Subscription.subscription_slug,
              application: teamId
            },
            data = {
              NewSuiApplicationsNewSuiUser: {
                id: currentMemberStatus === "unsaved" ? null : currentLinkId,
                role_code: index ? 'membro' : 'orientador',
                extra_data: {
                  exemption: formUserData.exemption || 'false',
                  exemptionStamp: formUserData.exemptionStamp,
                  exemptionProof: formUserData.exemptionProof
                },
                NewSuiUser: {
                  email: formUserData.email,
                  name: formUserData.name,
                  surname: formUserData.surname,
                  sui_grade_id: formUserData.sui_grade_id,
                  gender: formUserData.gender,
                  professor_type: formUserData.professor_type
                }
              }
            };

        if (context.getters.currentSubsModel != 'onhb') {//AQUI
          data.NewSuiApplicationsNewSuiUser.NewSuiUser._extra = {
            auxId: currentMemberId,
            profession: formUserData.profession,
            age: formUserData.age,
            gender: formUserData.gender,
            professor_type: formUserData.professor_type,
            schooling: formUserData.schooling,
            onhb_already: formUserData.onhb_already,
            state: formUserData.state,
            city: formUserData.city
          };

          extraData = data.NewSuiApplicationsNewSuiUser.NewSuiUser._extra;
        }

        promise = Vue.axios.post('new_sui_application.json?' + (new URLSearchParams(params).toString()), data)
      }

      return promise
          .then(
              function(response) {
                if (!response.data.saved) {
                  alert_validation_messages(response.data.validation, "Não foi possível cadastrar o componente da equipe.");
                  return;
                }

                let memberData = response.data.data.NewSuiApplicationsNewSuiUser;

                context.commit("UPDATE_SAVED_MEMBER", {
                  teamId,
                  index,
                  member: memberData,
                  extraData: extraData
                });

                if (memberData && memberData.NewSuiCoupon && memberData.NewSuiCoupon.code) {
                  context.commit("SET_DISCOUNT_COUPON",
                    {
                      code: memberData.NewSuiCoupon.code,
                      id: memberData.NewSuiCoupon.id,
                      type: memberData.NewSuiCoupon.type,
                      team_id: teamId,
                    });
                }
                else {
                  Vue.set(context.state.Teams[teamId].NewSuiCoupon, 'id', null);
                  Vue.set(context.state.Teams[teamId].NewSuiCoupon, 'code', null);
                  Vue.set(context.state.Teams[teamId].NewSuiApplication, 'sui_coupon_id', null);
                  context.commit("SET_DISCOUNT_COUPON", {code: null, id: null, type: null, team_id: null});
                }

                let name = formUserData.name + ' ' + formUserData.surname;
                let realName = memberData.NewSuiUser.name + ' ' + memberData.NewSuiUser.surname;

                if (memberData.NewSuiUser.user_status == 'validated' && name != realName) {
                  alert('O usuário já tem uma conta validada e o seu nome cadastrado (' + realName + ')' +
                  ' diverge do informado (' + name + '). Certifique-se de ser a mesma pessoa. Usaremos sempre ' +
                    'o nome informado no cadastro. Caso deseje alterar o nome, ' +
                    'peça para o usuário alterar seus dados pessoais no cadastro.');
                }

                if (context.getters.currentSubsModel != 'onhb') {
                  let maxMembers = 5;

                  if (context.state.Teams[teamId].NewSuiApplicationsNewSuiUser.length - 1 == index && index < maxMembers - 1) {
                    context.commit("ADD_EXTRA_MEMBER", {teamId});
                  }
                }
              },
              function () {
                alert("Falha ao cadastrar o componente da equipe")
              }
          ).
          finally(function () {
            context.commit("END_LOADING");
          })
    },
    removeMember: function (context, {teamId, index}) {

      let promise,
          member_id = context.state.Teams[teamId].NewSuiApplicationsNewSuiUser[index].sui_user_id,
          member = context.state.Members[member_id],
          currentMemberId = member.NewSuiUser.id;

      if (!confirm(`Tem certeza que deseja remover o membro da equipe:\n - ${member.NewSuiUser.name} ${member.NewSuiUser.surname} (${member.NewSuiUser.email})`)) {
        return;
      }

      context.commit("START_LOADING");

      if (process.env.VUE_APP_API_MODE === "mock") {
        promise = new Promise(function(resolve){
          setTimeout(function() {
            resolve();
          }, 800);
        });
      }
      else {
        let params = {
              action: "remove_member",
              sui_user: context.state.User.NewSuiUser.id,
              subscription: context.state.Subscription.subscription_slug,
              application: teamId,
              user_removed: currentMemberId
            };

        promise = Vue.axios.post('new_sui_application.json?' + (new URLSearchParams(params).toString()), {})
      }

      return promise
          .then(
              function(response) {
                if (!response.data.saved) {
                  alert_validation_messages(response.data.validation, "Não foi possível remover o componente da equipe.");
                  return;
                }

                context.commit("REMOVE_MEMBER", {teamId, index});
                Vue.set(context.state.Teams[teamId].NewSuiCoupon, 'id', null);
                Vue.set(context.state.Teams[teamId].NewSuiCoupon, 'code', null);
                Vue.set(context.state.Teams[teamId].NewSuiApplication, 'sui_coupon_id', null);
                context.commit("SET_DISCOUNT_COUPON", {code: null, id: null, type: null, team_id: null});
              },
              function () {
                alert("Falha ao remover o componente da equipe")
              }
          ).
          finally(function () {
            context.commit("END_LOADING");
          })
    }
  },
  getters: {
    subsStillGoing: function (state) {
      let yep = false;

      try {
        yep = state.NewSuiSubscription.CurrentPeriod.auto_status === 'current';
        // eslint-disable-next-line no-empty
      } catch (err) {}

      return yep;
    },
    teamSubsStillGoing: function (state) {
      return (
        new Date() >= new Date('2026-02-15T00:41:00')
        && new Date() <= new Date('2026-04-02T23:59:59')
      );
    },
    teamExemptionStillGoing: function (state) {
      return (
        new Date() >= new Date('2026-02-15T00:00:00')
        && new Date() <= new Date('2026-03-16T23:59:59')
      );
    },
    currentPeriodEnd: function (state) {
      try {
        return new Date(state.NewSuiSubscription.CurrentPeriod.end);
        // eslint-disable-next-line no-empty
      } catch (err) {}

      return null;
    },
    alreadyStarted: function (state, getters) {
       if (getters.currentSubsModel != 'onhb') {
         return (new Date()) > (new Date('2026-04-06T01:00:00'));
       } else {
         return (new Date()) > (new Date('2026-04-06T01:00:00'));
       }
    },
    paymentDue: function(state) {
      let maximumDue = state.NewSuiSubscription.CurrentPeriod.payment_date.slice(0,10);
      let due = new Date();

      due.setDate(due.getDate() + parseInt(state.NewSuiSubscription.CurrentPeriod.payment_days));
      due = due.toISOString().slice(0,10);

      due = due < maximumDue ? due : maximumDue;

      return due;
    },
    registrationCost: function(state, getters) {
      return function (quantity) {
        if (typeof quantity === "undefined") {
          quantity = getters.numberOfTeams;
        }

        let publicPrice, publicPriceSelection, privatePrice, i;

        for (i = 0; i < state.NewSuiSubscription.CurrentPeriod.NewSuiPeriodCost.length; i++) {
          if (state.NewSuiSubscription.CurrentPeriod.NewSuiPeriodCost[i].group_type == 'publica') {
            publicPrice = parseFloat(state.NewSuiSubscription.CurrentPeriod.NewSuiPeriodCost[i].price);
          }
          else if (state.NewSuiSubscription.CurrentPeriod.NewSuiPeriodCost[i].group_type == 'publica_com_selecao') {
            publicPriceSelection = parseFloat(state.NewSuiSubscription.CurrentPeriod.NewSuiPeriodCost[i].price);
          }
          else if (state.NewSuiSubscription.CurrentPeriod.NewSuiPeriodCost[i].group_type == 'particular') {
            privatePrice = parseFloat(state.NewSuiSubscription.CurrentPeriod.NewSuiPeriodCost[i].price);
          }
        }

        if (state.Subscription.Ephemeral.Payment.sui_coupon_id) {
          quantity--;
        }

        let type = state.Subscription.NewSuiApplication.NewSuiInstitution.type;
        let cost = 0;
        if (type == 'private') {
          cost = privatePrice;
        }
        else if (type == 'public') {
          cost = publicPrice;
        }
        else if (type == 'public_with_selection') {
          cost = publicPriceSelection;
        }

        cost = quantity * cost;
        // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        return cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    numberOfTeams: function(state) {
      let teachers = state.Subscription.NewSuiApplication.extra_data._onhbSubscription.Teachers,
          teams = 0;

      if (state.Subscription.NewSuiApplication.modality == 'student') {
        return 1;
      }

      teachers.forEach(t => {
        let n = parseInt(t.teams);
        if (!isNaN(n)) {
          teams += parseInt(t.teams);
        }
      });
      return teams;
    },
    currentSubsStepPublicFacingName: function(state) {
      return state.Subscription.StepsPublicFacingNames[
        state.Subscription.Ephemeral.currentStep
      ];
    },
    currentSubsStep: function(state) {
      return state.Subscription.Ephemeral.currentStep;
    },
    currentModality: function(state) {
      return state.Subscription.NewSuiApplication.modality;
    },
    amILoading: function(state) {
      return state.ProcessingStatus.loadingSomething;
    },
    chosenSchoolData: function(state) {
      return state.Subscription.NewSuiApplication;
    },
    teacherList: function(state) {
      return state.Subscription.NewSuiApplication.extra_data._onhbSubscription.Teachers;
    },
    userFormSubStep: function (state) {
      return state.User.Ephemeral.subStep;
    },
    currentUser: function(state) {
      return state.User.NewSuiUser;
    },
    modalShown: function(state) {
      return state.ProcessingStatus.modal;
    },
    billetWarnShown: function (state) {
      return state.Interface.billetWarn;
    },
    newBilletShown: function (state) {
      return state.Interface.newBillet;
    },
    cancelApplicationShown: function (state) {
      return state.Interface.cancelApplication;
    },
    currentSubsModel: function (state) {
      //@todo Replace by something comming from the config
      switch (state.Subscription.subscription_slug) {
        case 'onhb12':
        case 'onhb_12':
        case 'omu_2021':
        case 'omu_2022':
        case 'omu_2023':
        case 'omu_2024':
        case 'omu_2025':
        case 'omu_2026':
        case 'omu_2026_hyw':
          return "onhb";
        default:
          return "preonhb";
      }
    },
    settingsUp: function (state) {
      return state.settingsLoaded;
    },
    subscriptionName: function (state) {
      return state.Subscription.title;
    }
  }
});
